import { VISA } from '../../constants/partnering-networks';
import getNetworkInstance from '../../helpers/get-network-instance';
import { trackRecognizedUser } from '../../helpers/gtm';
import OrchCustomData from '../../helpers/orch-custom-data';
import updateDpaLocale from '../../helpers/update-dpa-locale';
/*
 * This polls the isRecognized response cache for isRecog response.
 * network sdk should have already called isRecognized as part of initializeVSB()
 */
const isRecognizedForButtonless = () => {
  const vsbGtmData = { isError: false, isRequest: true, isVsb: true };
  trackRecognizedUser({}, OrchCustomData, vsbGtmData);
  return new Promise(resolve => {
    Promise.all(OrchCustomData.srcSdks.isRecognizedPromiseArr).then(responses => {
      let recognized = false;
      let usedDevice = false;
      for (const response of responses) {
        if (response?.res?.usedDevice !== undefined) {
          usedDevice = response.res.usedDevice;
        }
        if (response?.res?.recognized) {
          const vco = getNetworkInstance(OrchCustomData, VISA);
          vco.trackGuestVcoAccountEvent();
          recognized = true;
          usedDevice = true;
        }
        if (response?.res?.customData) {
          const locale = response.res.customData?.data?.data?.locality?.locale;
          if (locale) {
            const initData = OrchCustomData.initData;
            for (const network in initData) {
              if (network !== VISA) {
                updateDpaLocale(initData[network], locale);
              }
            }
          }
        }
      }
      const isRecognizedResponseCache = OrchCustomData.srcSdks.apiResponseCache.isRecognized;
      let idTokens = [];

      // convert isRecognizedResponseCache object into array in order control order of networks in trackRecognizedUser gtm call
      const isRecognizedResponseCacheArray = Object.entries(isRecognizedResponseCache).map(
        entry => {
          return { [entry[0]]: entry[1] };
        }
      );

      const isNetworkRecognized = isRecognizedResponseCacheArray.some(resp => {
        return resp.res?.recognized === true;
      });

      if (!isNetworkRecognized) {
        //VCO-15255 - the last object in isRecognizedResponseCacheArray sets gtm state. If not recognized default to Visa.
        isRecognizedResponseCacheArray.sort(a => (a.network === 'VISA' ? 1 : -1));
      } else {
        //VCO-15255 - the last object in isRecognizedResponseCacheArray sets gtm state. If recognized set to correct network.
        isRecognizedResponseCacheArray.sort(a => (a.res?.recognized ? 1 : -1));
      }

      isRecognizedResponseCacheArray.forEach(networkObj => {
        for (const network in networkObj) {
          const vsbGtmData = { isError: false, isRequest: false, isVsb: true };
          trackRecognizedUser(
            { [network]: isRecognizedResponseCache[network] },
            OrchCustomData,
            vsbGtmData,
            isRecognizedResponseCache[network].recognized
          );
          if (isRecognizedResponseCache[network].recognized) {
            idTokens = [...idTokens, ...isRecognizedResponseCache[network].idTokens];
          }
        }
      });

      resolve({
        idTokens,
        recognized,
        usedDevice
      });
    });
  });
};

export default isRecognizedForButtonless;
